const mainLayoutRouter = [
    {
        path:'denture/:clinic',
        name:'denture',
        component:() => import(/* webpackChunkName: "about" */ '../views/denture.vue')
    },
    {
        path:'orthodontics/:clinic/:code',
        name:'main',
        component:() => import(/* webpackChunkName: "about" */ '../views/index.vue')
    },
    // {
    //     path: ':code',
    //     redirect: (to) => {
    //         const defaultClinic = 'auu';
    //         const defaultCode = 'xxxxx';
    //         return `/${defaultClinic}/${to.params.code || defaultCode}`;
    //     }
    // },
    // // 捕获所有其他无效路径，重定向到默认路径
    // {
    //     path: '*', // 捕获所有路径
    //     redirect: (to) => {
    //         // 如果 `clinic` 参数缺失或路径无效，重定向到默认路径
    //         const defaultClinic = 'auu';
    //         const defaultCode = 'xxxxx';
    //         return `/${defaultClinic}/${defaultCode}`;
    //     }
    // }
]
export default mainLayoutRouter